var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header flex-row"},[_c('img',{staticClass:"icon",attrs:{"src":require("../assets/images/model-com/icon.png"),"alt":""}}),_c('p',{staticClass:"left"},[_vm._v(_vm._s(_vm.left))])])
}
var staticRenderFns = []

export { render, staticRenderFns }